import { z } from "zod";

import { PinnedTabScope } from "@signalist/shared-types";

import { CampaignPinnedTabFiltersSchema } from "@/pages/Private/pages/Campaigns/utils/campaignPinnedFilterTabs";
import { PinnedTabFiltersSchema } from "@/pages/Private/pages/List/utils/pinnedFilterTabs";

/**
 * A pinned tab as returned by the API. `filters` is validated against the schema of the scope that
 * was requested — the two overviews store different snapshot shapes in the same column, so a
 * response is only parseable when the request narrowed the scope (see the `scope` query param).
 */
const pinnedTabSchema = <T extends z.ZodTypeAny>(filters: T) =>
	z.object({
		id: z.number(),
		name: z.string(),
		filters,
		// Legacy rows predate the column; the API defaults them to LIST, but tolerate its absence.
		scope: z.nativeEnum(PinnedTabScope).optional(),
		createdAt: z.string(),
		updatedAt: z.string(),
	});

export const ListOverviewPinnedTabSchema = pinnedTabSchema(PinnedTabFiltersSchema);
export const CampaignsOverviewPinnedTabSchema = pinnedTabSchema(CampaignPinnedTabFiltersSchema);

export const ListOverviewPinnedTabsResponseSchema = z.object({
	data: z.array(ListOverviewPinnedTabSchema),
});

export const CampaignsOverviewPinnedTabsResponseSchema = z.object({
	data: z.array(CampaignsOverviewPinnedTabSchema),
});

export const ListOverviewPinnedTabDeleteResponseSchema = z.object({
	success: z.boolean(),
});

export type ListOverviewPinnedTabDto = z.infer<typeof ListOverviewPinnedTabSchema>;
export type CampaignsOverviewPinnedTabDto = z.infer<typeof CampaignsOverviewPinnedTabSchema>;
export type ListOverviewPinnedTabsResponse = z.infer<typeof ListOverviewPinnedTabsResponseSchema>;
export type CampaignsOverviewPinnedTabsResponse = z.infer<
	typeof CampaignsOverviewPinnedTabsResponseSchema
>;
export type ListOverviewPinnedTabDeleteResponse = z.infer<
	typeof ListOverviewPinnedTabDeleteResponseSchema
>;
